import { logEventData } from 'Util/Gtm';
import {
    ENTRY_POINT_SUCCES_PAGE,
    ENTRY_POINT_TWO
} from 'Util/Gtm/Gtm.config';
import {
    fetchQuery
} from 'Util/Request';

import { PAGE_TYPE_CHECKOUT_SUCCESS } from '../component/GoogleTagManager/GoogleTagManager.config';
import { EVENT_GTM_DYNAMIC_RETARGETING, EVENT_GTM_PURCHASE }
from '../component/GoogleTagManager/GoogleTagManager.events';
import GtmPurchaseQuery from '../query/GtmPurchase.query';

const getPurchase = (orderID, event, setPageType) => {
    const query = GtmPurchaseQuery.getGTMPurchase(orderID);

    fetchQuery(query).then(({ purchase }) => {
        logEventData({
            entry: ENTRY_POINT_TWO,
            eventDetails: {
                event, orderID, purchase
            }
        });
        setPageType(PAGE_TYPE_CHECKOUT_SUCCESS);
        event(EVENT_GTM_DYNAMIC_RETARGETING, PAGE_TYPE_CHECKOUT_SUCCESS);
        event(EVENT_GTM_PURCHASE, { ...purchase, orderID });
    });
};

const render = (args, callback, instance) => {
    const { orderID, event, setPageType } = instance.props;

    if (orderID) {
        getPurchase(orderID, event, setPageType);
    }
    logEventData({ clearAndLog: true, entry: ENTRY_POINT_SUCCES_PAGE });
    return callback.apply(instance, args);
};

export default {
    'Component/CheckoutSuccess/Component': {
        'member-function': {
            render
        }
    }
};
